var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62523_23063)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6.25,
    r: 2.75,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25002 11.6592C11.0794 11.4469 12.9197 11.447 14.749 11.6592C15.7371 11.7506 16.7197 11.9331 17.6885 12.2051C18.1924 12.3416 18.7346 12.5295 19.2457 12.7952C20.269 13.3269 19.6808 14.5 18.5276 14.5C18.3004 14.5 18.0773 14.4467 17.8657 14.3641C17.6446 14.2778 17.4091 14.2018 17.1651 14.1357C17.1592 14.1341 17.1533 14.1325 17.1475 14.1308C16.2937 13.8912 15.4311 13.7305 14.5654 13.6504C14.5501 13.6489 14.5339 13.6473 14.5186 13.6455C12.8424 13.4511 11.1567 13.451 9.48049 13.6455C9.46456 13.6473 9.4486 13.6489 9.43264 13.6504C8.56812 13.7295 7.70611 13.8896 6.85353 14.1299C6.84716 14.1317 6.8404 14.134 6.834 14.1357C5.64922 14.4568 4.86973 15.0171 4.64846 15.5898C4.55334 15.8565 4.49909 16.1658 4.50002 16.4902V16.498C4.49974 16.8361 4.55644 17.1589 4.65627 17.4385C4.85581 17.9659 5.43005 18.4097 6.38576 18.7226L6.82131 18.8496L6.89064 18.8681C7.6242 19.0854 8.36553 19.2369 9.10939 19.3222L9.42873 19.3554L9.59572 19.3769C9.65118 19.3867 9.70627 19.3987 9.76076 19.4131C9.77756 19.4175 9.81543 19.4262 9.89553 19.4316L10.2725 19.4385L10.4141 19.4433C11.7845 19.5408 13.1583 19.5125 14.5264 19.3594C14.5405 19.3578 14.5552 19.3567 14.5694 19.3554C15.426 19.2782 16.28 19.1151 17.124 18.8672C17.1443 18.8612 17.1651 18.8559 17.1856 18.8506C17.4236 18.7888 17.6542 18.7163 17.8713 18.6331C18.0818 18.5524 18.3033 18.5 18.5288 18.5C19.684 18.5 20.2749 19.6762 19.2483 20.206C18.7364 20.4702 18.1933 20.655 17.6885 20.7861C16.7209 21.0704 15.738 21.2575 14.749 21.3467C13.2602 21.5133 11.7645 21.5445 10.2725 21.4385C10.1256 21.4385 9.98071 21.4383 9.83608 21.4311C9.44181 21.4114 9.05186 21.3329 8.66038 21.282C7.87459 21.1799 7.09408 21.0144 6.32326 20.7861C4.96868 20.4374 3.36097 19.7099 2.77541 18.1181C2.59343 17.6112 2.49946 17.0562 2.50002 16.4951C2.49848 15.939 2.5926 15.3896 2.77541 14.8886C3.34941 13.3725 4.96837 12.5689 6.31154 12.2051C7.2801 11.9321 8.26202 11.7496 9.25002 11.6592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16.5H20.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62523_23063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollow);
export default __webpack_public_path__ + "static/media/Unfollow.3fe044b7f9a57b50a6a1767105a23281.svg";
export { ForwardRef as ReactComponent };